var _path, _path2, _ellipse, _ellipse2, _rect, _rect2, _path3, _ellipse3, _circle, _circle2, _ellipse4, _ellipse5, _circle3, _circle4, _ellipse6, _ellipse7, _circle5, _circle6, _ellipse8, _ellipse9, _circle7, _circle8, _ellipse10, _circle9, _circle10, _circle11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOil(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 76,
    viewBox: "0 0 35 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.2411C0 9.58423 1.34315 8.24109 3 8.24109H10.5H32C33.6569 8.24109 35 9.58423 35 11.2411V73C35 74.6569 33.6569 76 32 76H3C1.34315 76 0 74.6569 0 73V11.2411Z",
    fill: "#DCCD31"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3717 10.986C15.2564 9.15665 15.4606 4.58433 14.7265 2.04625L22.0802 2.42883C20.9143 5.70136 21.5384 8.69879 26.9178 11.8468C21.3407 12.3899 7.27817 12.1445 10.3717 10.986Z",
    fill: "#DCCD31"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.061,
    cy: 1.22088,
    rx: 7.29167,
    ry: 1.22088,
    fill: "#E5B96E"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.061,
    cy: 3.66265,
    rx: 7.29167,
    ry: 1.22088,
    fill: "#E5B96E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.7693,
    y: 1.22095,
    width: 14.5833,
    height: 2.44176,
    fill: "#E5B96E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.29163,
    y: 18.0081,
    width: 21.875,
    height: 45.1726,
    rx: 2,
    fill: "#FEF3E3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8557 41.7723C15.3633 41.7723 14.9312 41.6551 14.5596 41.4208C14.1902 41.1864 13.9014 40.8585 13.6931 40.4371C13.4871 40.0157 13.3841 39.5233 13.3841 38.9598C13.3841 38.3916 13.4871 37.8957 13.6931 37.4719C13.9014 37.0481 14.1902 36.7191 14.5596 36.4847C14.9312 36.2503 15.3633 36.1331 15.8557 36.1331C16.3481 36.1331 16.779 36.2503 17.1483 36.4847C17.52 36.7191 17.8088 37.0481 18.0148 37.4719C18.2231 37.8957 18.3273 38.3916 18.3273 38.9598C18.3273 39.5233 18.2231 40.0157 18.0148 40.4371C17.8088 40.8585 17.52 41.1864 17.1483 41.4208C16.779 41.6551 16.3481 41.7723 15.8557 41.7723ZM15.8557 41.0195C16.2298 41.0195 16.5375 40.9236 16.779 40.7318C17.0205 40.5401 17.1992 40.288 17.3152 39.9755C17.4312 39.663 17.4892 39.3244 17.4892 38.9598C17.4892 38.5952 17.4312 38.2555 17.3152 37.9407C17.1992 37.6258 17.0205 37.3713 16.779 37.1772C16.5375 36.983 16.2298 36.886 15.8557 36.886C15.4817 36.886 15.1739 36.983 14.9324 37.1772C14.6909 37.3713 14.5122 37.6258 14.3962 37.9407C14.2802 38.2555 14.2222 38.5952 14.2222 38.9598C14.2222 39.3244 14.2802 39.663 14.3962 39.9755C14.5122 40.288 14.6909 40.5401 14.9324 40.7318C15.1739 40.9236 15.4817 41.0195 15.8557 41.0195ZM19.6066 41.6587V36.2041H20.4447V41.6587H19.6066ZM20.0327 35.2951C19.8694 35.2951 19.7285 35.2394 19.6102 35.1282C19.4942 35.0169 19.4361 34.8831 19.4361 34.7269C19.4361 34.5706 19.4942 34.4369 19.6102 34.3256C19.7285 34.2143 19.8694 34.1587 20.0327 34.1587C20.1961 34.1587 20.3358 34.2143 20.4518 34.3256C20.5701 34.4369 20.6293 34.5706 20.6293 34.7269C20.6293 34.8831 20.5701 35.0169 20.4518 35.1282C20.3358 35.2394 20.1961 35.2951 20.0327 35.2951ZM22.8177 34.386V41.6587H21.9797V34.386H22.8177Z",
    fill: "#BEAA28"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.8,
    cy: 9.80002,
    rx: 2.8,
    ry: 1.4,
    fill: "#868787"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.90005,
    cy: 9.1,
    r: 2.1,
    fill: "#868787"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.1,
    cy: 11.9,
    r: 2.1,
    fill: "#868787"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.90005,
    cy: 11.2,
    rx: 2.1,
    ry: 1.4,
    fill: "#868787"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22,
    cy: 9,
    rx: 2,
    ry: 1,
    fill: "#868787"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 8.5,
    r: 1.5,
    fill: "#868787"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 10.5,
    r: 1.5,
    fill: "#868787"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.5,
    cy: 10,
    rx: 1.5,
    ry: 1,
    fill: "#868787"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10,
    cy: 11,
    rx: 2,
    ry: 1,
    fill: "#868787"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 10.5,
    r: 1.5,
    fill: "#868787"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 12.5,
    r: 1.5,
    fill: "#868787"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.5,
    cy: 12,
    rx: 1.5,
    ry: 1,
    fill: "#868787"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.2,
    cy: 7.19998,
    rx: 3.2,
    ry: 1.6,
    fill: "#868787"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.6,
    cy: 6.4,
    r: 2.4,
    fill: "#868787"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.4,
    cy: 9.59995,
    r: 2.4,
    fill: "#868787"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.6,
    cy: 8.79995,
    rx: 2.4,
    ry: 1.6,
    fill: "#868787"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 11.5,
    r: 0.5,
    fill: "#868787"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 0.5,
    fill: "#868787"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 11.5,
    r: 0.5,
    fill: "#868787"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOil);
export default __webpack_public_path__ + "static/media/oil.5207bcad02856badf9f6b978d1c6795d.svg";
export { ForwardRef as ReactComponent };